import styled from 'styled-components'
import { Text } from '../../ui/primitives'

export const StatusText = styled(Text)`
  display: flex;
  align-items: center;
  font-weight: bold;
  min-height: 22px;
`
